import { IDocumentRepository } from "domain/contracts/document.contracts";
import { DocumentInputFilter } from "domain/models/document-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { Document } from "../../domain/entities/document";

class DocumentRepository implements IDocumentRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/document/${id}`);
    return response.data;
  }

   async deleteCPS(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/document/cps/${id}`);
    return response.data;
  }

  // async update(input: Document): Promise<Message<boolean>> {
  //   const response = await httpClient.put(`/document/${input.id}`, {
  //     data: input,
  //   });
  //   return response.data;
  // }
  async create(input: Document): Promise<Message<Document>> {
    const response = await httpClient.post(`/document`, { data: input });
    return response.data;
  }

  async createCPS(input: Document): Promise<Message<Document>> {
    const response = await httpClient.post(`/document/cps`, { data: input });
    return response.data;
  }

  async getAll(filter: DocumentInputFilter): Promise<Message<Document[]>> {
    const response = await httpClient.get(`/document`, {
      params: filter,
    });
    return response.data;
  }
}

export default new DocumentRepository();
